import { render, staticRenderFns } from "./CaptrainItemInfo.vue?vue&type=template&id=34ff1268&scoped=true&"
import script from "./CaptrainItemInfo.vue?vue&type=script&lang=js&"
export * from "./CaptrainItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./CaptrainItemInfo.vue?vue&type=style&index=0&id=34ff1268&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ff1268",
  null
  
)

export default component.exports